import classNames from 'classnames';
import { FormSelect } from 'react-bootstrap';
import './StateSelector.scss';
import { getUSStates } from '../../../utils/locations';

const StateSelector = ({
  selectedState,
  selectedStateCode,
  setSelectedState,
  setSelectedStateCode,
  variant = 'default',
}) => {
  const selectedOption = JSON.stringify({ name: selectedState, code: selectedStateCode });
  const isDs20 = variant === 'ds20';

  const options = getUSStates().map((state) => (
    <option className="state-select-option" key={state.code} value={JSON.stringify(state)}>
      {state.name}
    </option>
  ));

  const onSelectChange = ({ target }) => {
    const { name, code } = JSON.parse(target.value);
    setSelectedState(name);
    setSelectedStateCode(code);
  };

  const selectShared = {
    id: 'state',
    value: selectedOption,
    defaultValue: selectedOption,
    onChange: onSelectChange,
    children: options,
  };

  if (isDs20) {
    return (
      <div className="state-select-container state-select-container--ds20">
        <div className="state-select-container__ds20-block">
          <div className="state-select-container__ds20-notch">
            <span id="state-label-ds20" className="state-select-container__ds20-labelText">
              State *
            </span>
          </div>
          <div className="state-select-container__ds20-control">
            <FormSelect
              {...selectShared}
              className={classNames('state-select', 'state-select--ds20')}
              aria-labelledby="state-label-ds20"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="state-select-container">
      <FormSelect
        {...selectShared}
        className="state-select"
        label="State*"
      />
    </div>
  );
};

export default StateSelector;
